<template>
  <div id="paypal-button-container"></div>
</template>

<script>
import * as curApi from "@/api/tcode/subscriptions";
import * as cache from "@/utils/cache";

export default {
  name: 'PayPalButton',
  props: {
    planid: {
      type: String,
      default: ''
    },
    amount: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: 'USD'
    },
    description: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: 'sandbox',  //TODO: 测试环境
      //default: 'production', //TODO: 正式环境
      validator: value => ['sandbox', 'production'].includes(value)
    }
  },
  data() {
    return {
      paypalClientIds: {
        sandbox: 'ASpl6LT-FtIT4J-5x3NKN1HmZiPJHxQk_O8qhXz3Lel53wv6lNlDcv7L7QrDnQKjwjBKGe-gVqOjgSyi', // 替换为你的实际ID
        production: 'AZJK-SUgPQPWq-pPBJxrQGiMsxpib8awyhOC567RSaaXYwks7wNKl1nK8sTqfCjx5SNkG41jNdnU-bha' // 替换为你的实际ID
      },
      formData: {
        id_plan: "",
        pk_user: "",
        id:"",
        id_order:"",
        paypalCode: ""
      }
    };
  },
  mounted() {
    this.loadPayPalSDK();
  },
  methods: {
    loadPayPalSDK() {
      return new Promise((resolve, reject) => {
        // 移除已存在的脚本
        const existingScript = document.getElementById('paypal-sdk');
        if (existingScript) {
          document.body.removeChild(existingScript);
        }

        const script = document.createElement('script');
        script.id = 'paypal-sdk';
        //TODO: 测试环境
        script.src = `https://www.sandbox.paypal.com/sdk/js?client-id=${this.paypalClientIds[this.env]}&vault=true&intent=subscription`;
        //TODO: 正式环境
        //script.src = `https://www.paypal.com/sdk/js?client-id=${this.paypalClientIds[this.env]}&vault=true&intent=subscription`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load PayPal SDK'));
        document.body.appendChild(script);
      })
        .then(() => this.renderPayPalButton())
        .catch(error => {
          console.error('Failed to load PayPal SDK:', error);
          this.$emit('payment-error', error);
        });
    },
    renderPayPalButton() {
      if (!window.paypal) {
        const error = new Error('PayPal SDK not loaded correctly');
        console.error(error);
        this.$emit('payment-error', error);
        return;
      }

      try {
        window.paypal.Buttons({
          style: {
            shape: 'rect',
            color: 'gold',
            layout: 'vertical',
            label: 'pay',
            height: 40, // 设置按钮高度(px)
            width: 120,
            fundingicons: false, // 隐藏资助图标
            funding: {
              allowed: [window.paypal.FUNDING.PAYPAL], // 只允许PayPal账户支付
              disallowed: [window.paypal.FUNDING.CARD, window.paypal.FUNDING.CREDIT, window.paypal.FUNDING.VENMO] // 禁用所有其他支付方式
            }
          },
          createSubscription: (data, actions) => { // 使用箭头函数保持this指向
            return actions.subscription.create({
              plan_id: this.planid // 现在this指向Vue实例
            });
          },

          onApprove: (data, actions) => {
            this.formData.id_plan = this.planid;
            this.formData.pk_user = cache.getUserInfo().pk;
            this.formData.id_order = data.orderID;
            this.formData.id = data.subscriptionID;
            curApi.saveSubscription(this.formData).then(result => {
            }).catch(error => {
              console.error('Failed to save subscription:', error);
              this.$message({
                duration: 1500,
                message: "Failed to save subscription:"+error,
                type: 'error'
              });
              this.formData.id = data.subscriptionID;
              this.formData.reason = "failed to save subscription";
              //保存失败，取消订阅
              curApi.cancelSubscription(this.formData).then(resp => {
              }).catch(error => {
              })
            })
          },
          onCancel: function (data) {
          },
          onError: (err) => {
            console.error('PayPal error:', err);
            this.$emit('payment-error', err);
          }
        }).render('#paypal-button-container');

      } catch (error) {
        console.error('Failed to render PayPal button:', error);
        this.$emit('payment-error', error);
      }
    }
  }
};
</script>

<style scoped>
#paypal-button-container {
  margin: 15px 25px;
  min-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/member/PayPalButton.vue